import { useQuery } from '@tanstack/react-query';
import { sampleAccounts } from './api';

/**
 * Sample Workspace
 * interactive_demo_workspace / sample_workspace
 * Part of:
 * https://linear.app/customerio/project/sample-workspace-view-only-workspace-387ba35103c0/overview
 */

export const useSampleAccountsQuery = () => {
  return useQuery({
    queryKey: ['sampleAccounts'],
    queryFn: getSampleAccounts,
  });
};

export const getSampleAccounts = async () => {
  const resp = await sampleAccounts();
  const response = resp?.accounts?.[0] ?? { environment_ids: [] };

  return { accountId: response.id, workspaceId: response.environment_ids[0] };
};

export const useSampleWorkspace = () => {
  const { data: sampleAccount } = useSampleAccountsQuery();
  const sampleAccountId = sampleAccount?.accountId ?? null;
  const sampleWorkspaceId = sampleAccount?.workspaceId ?? null;

  const isSampleWorkspace = (workspaceId: number | null | undefined) => {
    if (workspaceId == null) {
      return false;
    }

    return workspaceId === sampleWorkspaceId;
  };

  return {
    sampleAccountId,
    sampleWorkspaceId,
    isSampleWorkspace,
  };
};
